import { useRef, useState } from "react";
import { Upload } from "lucide-react";
import { toast } from "sonner";
import { api, adminHeaders, assetUrl, errorText } from "@/lib/api";
import { useEvent } from "@/context/EventContext";

const KINDS = [
  { kind: "logo", title: "Etkinlik logosu", hint: "Köşe + Instax şeridi sağ. SVG/PNG, maks 2MB." },
  { kind: "sticker", title: "Sticker", hint: "Tam karede sol alt, şeritte sol. SVG/PNG, maks 2MB." },
];

const AssetCard = ({ kind, title, hint, onUnauthorized }) => {
  const { event, refresh } = useEvent();
  const ref = useRef(null);
  const [busy, setBusy] = useState(false);
  const current = assetUrl(event?.assets?.[kind]);

  const upload = async (e) => {
    const f = e.target.files?.[0];
    if (!f) return;
    setBusy(true);
    const form = new FormData();
    form.append("file", f);
    try {
      await api.post(`/admin/assets/${kind}`, form, { headers: adminHeaders() });
      toast.success(`${title} güncellendi`);
      await refresh();
    } catch (err) {
      if (err?.response?.status === 401) onUnauthorized();
      else toast.error(errorText(err, "Yükleme başarısız"));
    } finally {
      setBusy(false);
      e.target.value = "";
    }
  };

  return (
    <div className="glass p-5" data-testid={`asset-card-${kind}`}>
      <p className="eyebrow">{kind}</p>
      <h3 className="font-display mt-1 text-lg font-bold">{title}</h3>
      <p className="mt-1 text-xs text-slate-400">{hint}</p>
      <div className="mt-4 grid aspect-[3/2] place-items-center rounded-xl bg-white/90 p-4" style={{ backgroundImage: "linear-gradient(45deg,#eee 25%,transparent 25%,transparent 75%,#eee 75%),linear-gradient(45deg,#eee 25%,transparent 25%,transparent 75%,#eee 75%)", backgroundSize: "16px 16px", backgroundPosition: "0 0,8px 8px" }}>
        {current ? <img src={current} alt={title} className="max-h-full max-w-full object-contain" data-testid={`asset-preview-${kind}`} /> : <span className="text-xs text-slate-500" data-testid={`asset-empty-${kind}`}>Yüklenmemiş</span>}
      </div>
      <button className="btn btn-ghost mt-4 w-full" onClick={() => ref.current?.click()} disabled={busy} data-testid={`asset-upload-${kind}-button`}>
        <Upload size={16} /> {busy ? "Yükleniyor…" : "Dosya seç"}
      </button>
      <input ref={ref} type="file" accept=".svg,image/svg+xml,image/png,image/jpeg,image/webp" className="hidden" onChange={upload} data-testid={`asset-file-input-${kind}`} />
    </div>
  );
};

export const AssetManager = ({ onUnauthorized }) => (
  <section data-testid="asset-manager">
    <p className="eyebrow">Etkinlik varlıkları</p>
    <h2 className="font-display mt-1 text-xl font-extrabold">Logo & sticker</h2>
    <div className="mt-6 grid gap-4 sm:grid-cols-2">
      {KINDS.map((k) => (
        <AssetCard key={k.kind} {...k} onUnauthorized={onUnauthorized} />
      ))}
    </div>
  </section>
);
